export default __webpack_public_path__ + "static/media/user.inline.5465cb58.svg";